import { createFileRoute, Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";

export const Route = createFileRoute("/$lang/learn")({
  head: ({ params }) => ({
    meta: [
      { title: "Learn — MadCaptains" },
      { name: "description", content: "Recognizing manipulation, documenting abuse, your rights under MLC 2006, and who can help." },
      { property: "og:title", content: "Learn — MadCaptains" },
      { property: "og:description", content: "Recognizing manipulation, documenting abuse, your rights under MLC 2006, and who can help." },
      { property: "og:url", content: `/${params.lang}/learn` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/learn` }],
  }),
  component: LearnPage,
});

function LearnPage() {
  const { lang, t } = useI18n();
  return (
    <PageShell eyebrow={lang === "ru" ? "База знаний" : "Knowledge base"} title={t.page_learn_h1} lead={t.page_learn_lead}>
      <div className="space-y-10 text-[1.02rem] leading-[1.75]">
        <section>
          <h2 className="font-display text-2xl">{t.learn_alone_h2}</h2>
          <p className="mt-3 text-justify text-muted-foreground">{t.learn_alone_p}</p>
        </section>

        <section>
          <h2 className="font-display text-2xl">{t.learn_rights_h2}</h2>
          <p className="mt-3 text-justify text-muted-foreground">{t.learn_rights_p}</p>
          <ul className="mt-4 list-disc space-y-2 pl-5 text-muted-foreground">
            <li className="text-justify">{t.learn_rights_onboard}</li>
            <li className="text-justify">{t.learn_rights_shore}</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl">{t.learn_help_h2}</h2>
          <ul className="mt-4 list-disc space-y-2 pl-5 text-muted-foreground">
            <li className="text-justify">
              <span className="font-medium">{t.learn_help_itf}</span>{" "}
              <a
                href="https://itfseafarers.org"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
                style={{ color: "var(--amber)" }}
              >
                itfseafarers.org
              </a>{" "}
              {t.learn_help_itf_desc}
            </li>
            <li className="text-justify">
              <span className="font-medium">{t.learn_help_iswan}</span>{" "}
              <a
                href="https://seafarerhelp.org"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
                style={{ color: "var(--amber)" }}
              >
                seafarerhelp.org
              </a>{" "}
              {t.learn_help_iswan_desc}
            </li>
            <li className="text-justify">
              <span className="font-medium">{t.learn_help_nautilus}</span>{" "}
              <a
                href="https://nautilusint.org"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
                style={{ color: "var(--amber)" }}
              >
                nautilusint.org
              </a>{" "}
              {t.learn_help_nautilus_desc}
            </li>
            <li className="text-justify">{t.learn_help_flag}</li>
            <li className="text-justify">{t.learn_help_psc}</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl">{t.learn_not_h2}</h2>
          <p
            className="mt-3 text-justify rounded-sm border-l-2 p-4 font-display text-lg italic"
            style={{
              borderColor: "var(--amber)",
              background: "color-mix(in oklab, var(--amber) 6%, transparent)",
            }}
          >
            {t.learn_not_p}
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">{t.learn_danger_h2}</h2>
          <p className="mt-3 text-justify text-muted-foreground">{t.learn_danger_p}</p>
          <p className="mt-3">
            <Link
              to="/$lang/help"
              params={{ lang }}
              className="underline-offset-4 hover:underline"
              style={{ color: "var(--amber)" }}
            >
              {t.learn_danger_link}
            </Link>
          </p>
        </section>
      </div>
    </PageShell>
  );
}